module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAOCAYAAAD5YeaVAAABA0lEQVQokYXSvy+DURTG8U+vV9MOjRiYsNVikRCLkIgYrOg/wCIRE4lFOhmbGKx+jJQwGsztIIwsYpDGIAbSsdLB8r5JldaznJNzvyfPk3tv6uNwWJsK2MMuLloPQksfoYRzjMa1FM9/wBHOsNXmsoVyspDA+1huzxNrCQcJPI+NDmCidcwGbCP1Dww7AdNdkVSQndyBmYCebmzIDkjnCxAFvHaDe4fmNN/voRZQ6ZggnZMZ39R4PIFKwPFv70g0OCG3eOrr5Vrz7RZOIlRxqeWeM2Or0vkVjYdjjacyXPWv1aqp+G/04QZTf6S5w0L/Wq2evGAdsyjiGc24FjGD+ufRiG8TDjgJ8254UgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/index/con_title_img.png
// module id = r3jt
// module chunks = 1